'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import styles from './styles'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _Show = require('./Show');

var _Show2 = _interopRequireDefault(_Show);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var File = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(File, _React$Component);

  function File() {
    (0, _classCallCheck3.default)(this, File);
    return (0, _possibleConstructorReturn3.default)(this, (File.__proto__ || Object.getPrototypeOf(File)).apply(this, arguments));
  }

  (0, _createClass3.default)(File, [{
    key: 'render',
    value: function render() {
      if (this.props.value) {
        return _react2.default.createElement(_Show2.default, this.props);
      } else {
        return _react2.default.createElement(_Input2.default, this.props);
      }
    }
  }]);
  return File;
}(_react2.default.Component), _class.propTypes = {
  value: _propTypes2.default.object,
  placeholder: _propTypes2.default.node,
  upload: _propTypes2.default.func.isRequired,
  delete: _propTypes2.default.func
}, _class.defaultProps = {
  placeholder: 'Upload file',
  delete: function _delete() {}
}, _temp);
exports.default = File;